import React from 'react'
import { Segment, Icon, Header } from 'semantic-ui-react'
import { Button } from 'semantic-ui-react'

const MissingInfo = props => {
  return (
    <Segment>
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          height: 'calc(100vh - 160px)',
        }}
      >
        <div>
          <Header icon>
            <Icon name="warning sign" />
            Missing Information
          </Header>
        </div>
        <div>
          <Button primary onClick={() => props.history.push('/')}>
            Back to Home
          </Button>
        </div>
      </div>
    </Segment>
  )
}

export default MissingInfo



// WEBPACK FOOTER //
// ./src/components/invoice/shared/MissingInfo.js